module.exports = __webpack_public_path__ + "static/sign-in2-e332bea44a5b6f5f1f4a9528ab4fa22c.png";